import { lazy } from 'react'
import lazyLoad from './LazyLoad'

// 登录相关
export const pointRouter = [
  {
    element: lazyLoad(lazy(() => import('@/pages/point/index/indexSimple'))),
    path: '/point/list',
  }
  //
]